<template>
    <div class="modal-backdrop">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">选择层级</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-row class="row">
                    <el-tree
                            v-loading="loading"
                            :data="listZoneDTO"
                            node-key="Code"
                            default-expand-all
                            :props="defaultProps"
                            @node-click="SelectMune"
                            :expand-on-click-node="false">

                        <span class="custom-tree-node" slot-scope="{ node }">

                        <span  style="width:100%">
                            <div style="width:200px;float: left;">
                                <span class="sp">{{ node.data.name }}</span>
                            </div>
                        </span>
                        </span>
                    </el-tree>
                </el-row>


            </div>
        </div>

    </div>
</template>


<script>

    export default {
        name: 'Add',
        props: ['listZoneDTO'],
        data() {
            return {

                loading: false,
                level:'',
                defaultProps: {
                    children: 'children',
                    label: 'name'
                }


            }
        },
        methods: {
            init(){
                
            },
            closeSelf() {
                this.$emit("showModal");
            },
            SelectMune(data){
                console.log(data);
                this.$emit("setLevel",data.level);
                this.$emit("showModal");
            },
            confirm(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
            },




        }
    }
</script>


<style>
    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
    }
    .modal {
        background-color: #fff;
        box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width: 520px;
    }
    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }
    .modal-body {
        position: relative;
        padding: 20px;
        z-index: 99;
    }
    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }

</style>
